import { Phone, MessageCircle } from "lucide-react";
import { useLang, PHONE_TEL, waLink } from "@/i18n";

export const FloatingActions = () => {
    const { t } = useLang();
    return (
        <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3" data-testid="floating-actions">
            <a
                href={waLink(t("hero.waMsg"))}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="floating-whatsapp-button"
                aria-label="WhatsApp"
                className="gold-glow-hover animate-soft-pulse w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center text-white shadow-lg"
            >
                <MessageCircle size={24} />
            </a>
            <a
                href={PHONE_TEL}
                data-testid="floating-call-button"
                aria-label={t("floating.call")}
                className="gold-glow-hover w-14 h-14 rounded-full bg-[#D4AF37] flex items-center justify-center text-[#08080A] shadow-lg"
            >
                <Phone size={24} />
            </a>
        </div>
    );
};
